import cn from 'classnames';
import { useMediaQuery } from '@mui/material';

import { OButton, OResponsiveModal } from '@src/shared';

import { IAttendee } from '@src/webinar/types';

interface BulkActionModalProps {
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  handleAcknowledgeAttendeesByFilter: () => void;
  status: boolean;
  selectedAttendees: IAttendee[];
  isBulkActionLoading: boolean;
}

const BulkActionModal = ({
  isModalOpen,
  setIsModalOpen,
  handleAcknowledgeAttendeesByFilter,
  status,
  selectedAttendees,
  isBulkActionLoading,
}: BulkActionModalProps) => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const actionLabel = status ? 'Approve' : 'Reject';

  return (
    <OResponsiveModal
      isOpen={isModalOpen}
      title={isMobile ? `${actionLabel} Webinar Attendees` : undefined}
      modalClasses={{
        container: cn('!bg-white w-[45rem]'),
        closeIconWrapper: cn('!bg-[#F5F6F7]'),
        closeIcon: cn('!text-[#B14241]'),
      }}
      onClose={() => setIsModalOpen(false)}
    >
      <div className="text-center">
        {!isMobile && <h4 className="text-black">{actionLabel} Webinar Attendees</h4>}
        <p className="text-black mt-4 px-5">
          You're about to {actionLabel.toLowerCase()}{' '}
          <span className="font-semibold">{selectedAttendees.length} attendees</span> for webinar access. Once{' '}
          {status ? 'approved' : 'rejected'}, they will receive emails with the webinar join link and details.
        </p>
        <div className="flex gap-4 justify-center">
          <OButton
            text="Cancel"
            variant="primary"
            outlined
            size="medium"
            onClick={() => {
              setIsModalOpen(false);
            }}
          />
          <OButton
            text={'Confirm'}
            variant={status ? 'success' : 'danger'}
            size="medium"
            onClick={handleAcknowledgeAttendeesByFilter}
            loading={isBulkActionLoading}
          />
        </div>
      </div>
    </OResponsiveModal>
  );
};

export default BulkActionModal;
